import * as SheetPrimitive from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { XIcon } from 'lucide-react';
import { Link } from 'react-router';
import MuseaLogo from '~/assets/musea-logo';
import RightArrow from '~/assets/right-arrow';
import { useUserContext } from '~/context/user-context';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '../ui/sheet';

const links = [
  {
    label: 'Exposições',
    description: 'Veja as exposições disponíveis',
    href: '/',
  },
  {
    label: 'Seus favoritos',
    description: 'Entre para adicionar ou visualizar',
    loggedDescription: 'Adicionar ou visualize seus favoritos',
    href: '/favoritos',
  },
  {
    label: 'Locais',
    description: 'Mais de 30 locais disponíveis',
    href: '/locais',
  },
  // {
  //   label: 'Artistas',
  //   description: '30 artistas disponíveis',
  //   href: '/artistas',
  // },
  {
    label: 'Sobre o Musea',
    description: 'Contrate para a sua exposição ou galeria',
    href: '/sobre',
  },
  {
    label: 'Termos e condições de uso',
    description: 'Termos da plataforma',
    href: '/termos-de-uso',
  },
  {
    label: 'Excluir conta',
    description: 'Apague a sua conta do Musea',
    href: '/excluir-conta',
    logged: true,
  },
];

type Props = {
  closeMenu: () => void;
};

const MenuSheet = ({
  closeMenu,
  ...props
}: React.ComponentProps<typeof SheetPrimitive.Root> & Props) => {
  // context
  const { user, storeUser } = useUserContext();
  const logged = Boolean(user?.token);
  const handleLogout = () => {
    // closeMenu();
    storeUser(null);
  };
  // UI
  return (
    <Sheet {...props}>
      <VisuallyHidden>
        <SheetTitle>Menu</SheetTitle>
        <SheetDescription>Acesso às principais seções do Musea</SheetDescription>
      </VisuallyHidden>
      <SheetContent className="py-4 px-3 w-full lg:px-40 lg:min-w-[50%] bg-primary" side="left">
        <div>
          {/* header */}
          <div className="flex">
            <SheetPrimitive.Close>
              <XIcon size={24} color="black" />
              <span className="sr-only">Fechar</span>
            </SheetPrimitive.Close>
            <MuseaLogo className="ml-6" fill="black" />
          </div>
          {/* links */}
          <div className="mt-4">
            {links.map(link =>
              logged || !link.logged ? (
                <Link key={link.label} to={link.href} onClick={closeMenu}>
                  <div className="py-4">
                    <div className="flex items-center">
                      <p className="text-sm text-black">{link.label}</p>
                      <RightArrow className="ml-2" />
                    </div>
                    <p className="text-xs text-muted-foreground">
                      {logged && link.loggedDescription ? link.loggedDescription : link.description}
                    </p>
                  </div>
                </Link>
              ) : null
            )}
          </div>
          {/* action */}
          <div className="mt-4">
            {logged ? (
              <Button size="lg" onClick={handleLogout}>
                Sair
              </Button>
            ) : (
              <div>
                <Link to="/registro" className="w-full" onClick={closeMenu}>
                  <Button size="lg">Criar conta</Button>
                </Link>
                <Link to="/login" onClick={closeMenu}>
                  <p className="mt-4 ml-24 text-sm text-black underline">
                    Já tem conta? Clique aqui.
                  </p>
                </Link>
              </div>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

MenuSheet.displayName = 'MenuSheet';
export default MenuSheet;
